/*
 * @Author: heshouzhi heshouzhi@millionlab.cn
 * @Date: 2024-04-24 14:21:03
 * @LastEditors: heshouzhi heshouzhi@millionlab.cn
 * @LastEditTime: 2024-05-13 10:46:02
 * @FilePath: /web-crm/src/components/AlertML/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import Alert from '@material-ui/core/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import AlertTitle from '@material-ui/core/AlertTitle';
//success、 warning、 error、 info
export default ({
  parameter: { open, title, message, timeout = 1000, handleClose, type },
}) => {
  return (
    <Snackbar
      open={open}
      // sx={{border:'1px solid red'}}
      autoHideDuration={timeout}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleClose}
    >
      <Alert severity={type}>
        <AlertTitle sx={{ width: '219px' }}>{title}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  );
};
